import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { InputAddress, InputLogo, InputPanel, InputTextBox, InputVatNumber } from '@camelot/form-model';
import { graphQlUpdateFields } from '@camelot/server';
import { getModifiedValues } from '@camelot/utils';

import { Company } from '../dto/company';
import { CompanyCreationPayloadInput } from '../dto/company-creation-payload-input';
import { CompanyModifierPayloadInput } from '../dto/company-modifier-payload-input';

enum ECompanyFormFields {
  addressId = 'addressId',
  name = 'name',
  pictureDocumentId = 'pictureDocumentId',
  vatNumber = 'vatNumber',
}

@Injectable({
  providedIn: 'root',
})
export class CamCompanyFormService {
  public getCompanyForm(company: Company | null, options: { noTitle?: boolean; horizontal?: boolean } = {}) {
    const childClass = options.horizontal ? 'flex-fill' : '';
    const contentClass = options.horizontal ? 'flex-row g-space-md' : 'highlight-title g-space-md';
    return [
      new InputPanel({
        children: [
          new InputLogo({
            crop: { height: 256, shape: 'rectangle', width: 256 },
            key: ECompanyFormFields.pictureDocumentId,
            previewUrl: company?.pictureUrl,
            value: company?.pictureDocumentId ?? null,
          }),
        ],
        contentClass: 'flex-row g-space-md',
        key: 'picturePanel',
      }),
      new InputPanel({
        children: [
          new InputTextBox({
            class: childClass,
            key: ECompanyFormFields.name,
            label: 'organization.companies.form.name',
            validators: [Validators.required],
            value: company?.name,
          }),
          new InputVatNumber({
            class: childClass,
            key: ECompanyFormFields.vatNumber,
            label: 'organization.companies.form.vatNumber',
            value: company?.vatNumber,
          }),
        ],
        contentClass,
        key: 'panel',
      }),
      new InputAddress({
        key: ECompanyFormFields.addressId,
        label: 'organization.companies.form.address',
        persist: true,
        validators: [Validators.required],
        value: company?.addressId,
      }),
    ];
  }

  public companyCreateFormatForm(data: any): Partial<CompanyCreationPayloadInput> {
    return {
      addressId: data[ECompanyFormFields.addressId] ?? null,
      name: data[ECompanyFormFields.name] ?? null,
      vatNumber: data[ECompanyFormFields.vatNumber] ?? null,
    };
  }

  public companyUpdateFormatForm(data: any, company: Company): Partial<CompanyModifierPayloadInput> {
    const modifiedData = getModifiedValues(data, company);
    return {
      addressId: data[ECompanyFormFields.addressId] ?? null,
      id: company.id,
      name: data[ECompanyFormFields.name] ?? null,
      pictureDocumentId: data[ECompanyFormFields.pictureDocumentId] ?? null,
      vatNumber: data[ECompanyFormFields.vatNumber] ?? null,
      ...graphQlUpdateFields(modifiedData),
    };
  }
}
